module.exports = "bundles/f5ded3dd639e9991ca27dc50fc68be16.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/split.png
// module id = 139
// module chunks = 0